module.exports = __webpack_public_path__ + "img/opened-box.e7be3210.gif";